import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay, requireAuth } from '@/test/mocks/utils';

export type RequestTimezoneChangeResponse = {
  status: string;
  message: string;
  case_id?: string;
};

export const requestTimezoneChange =
  (): Promise<RequestTimezoneChangeResponse> => {
    return axios.post('/user/v1/tickets/timezone-change', {});
  };

export const requestTimezoneChangeMockHandler = http.post(
  `${env.API_URL}/user/v1/tickets/timezone-change`,
  async ({ cookies }): Promise<HttpResponse<RequestTimezoneChangeResponse>> => {
    await networkDelay();
    const { error } = requireAuth(cookies);
    if (error) {
      return HttpResponse.json(
        {
          status: 'error',
          message: error,
        },
        { status: 401 }
      );
    }

    const mockResponse: RequestTimezoneChangeResponse = {
      status: 'SUCCESS',
      message: 'Timezone change ticket created successfully',
      case_id: `5007100000${Date.now().toString().slice(-6)}Jp9MgAAJ`,
    };

    return HttpResponse.json(mockResponse);
  }
);
